var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.value.hidenShowPrompt)?_c('div',{staticClass:"categoryPrompt",style:({
   //'left': judgeFixed?  windowMove.left + 'px' : (windowMove.left + 290 + 'px'),
   //'left':'boxName==scenes'?362+10+'px':0+'px',
    'top':  (_vm.windowMove.top - 3 + (_vm.addHeight ? _vm.addHeight : 0)) + 'px',

  })},[_c('div',{staticClass:"promptBox"},[_vm._v("\n    "+_vm._s(_vm.dataArray[this.value.id].categoryAllData? _vm.dataArray[this.value.id].categoryAllData.name : '没有名字')+"\n    "),_c('span',{staticClass:"closeIcon el-icon-close",on:{"click":function($event){return _vm.closeCategory()}}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cfbe90a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rightnav/slide/search/categoryPrompt.vue
// module id = null
// module chunks = 